import { ROL } from '../lib/role.enum';
import { ESTADO_DENUNCIA } from '../lib/denuncia.enum';

/*
 * Permisos para poder interactuar con el chat
 */
const PERMISO_MENSAJES = [ROL.DENUNCIANTE, ROL.RESPONSABLE, ROL.ADMINISTRADOR];

/*
 * Permisos para poder interactuar con el chat
 */
const PERMISO_GESTION_DENUNCIA = [ROL.ADMINISTRADOR];

/*
 * Permisos para la descarga
 */
const PERMISO_DESCARGA = [ROL.AUTORIDAD, ROL.RESPONSABLE, ROL.ADMINISTRADOR, ROL.DENUNCIANTE];

/*
 * Permisos para escribir mensajes
 */
const SIN_PERMISO_ESCRIBIR_MENSAJES = [ESTADO_DENUNCIA.DESESTIMADA, ESTADO_DENUNCIA.FINALIZADA];

const PERMISO_BACKOFFICE = [ROL.AUTORIDAD, ROL.ADMINISTRADOR, ROL.RESPONSABLE];

export {
  PERMISO_MENSAJES,
  SIN_PERMISO_ESCRIBIR_MENSAJES,
  PERMISO_GESTION_DENUNCIA,
  PERMISO_DESCARGA,
  PERMISO_BACKOFFICE,
};
